import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation, withTranslation } from "react-i18next";
import { questionnaireActions } from "_actions";
import "./informes.scss"
import { Button, List } from "antd";
import localOrSessionStore from "../../../_helpers/localOrSessionStore";
import variables from "../../../_constants/variables";
import { ShareAltOutlined } from "@ant-design/icons";
import { xcService } from "../../../_services/xcService";
import { useLocation } from "react-router-dom";
import CardStudent from "./cardStudent";
import * as _ from "lodash";
import Tek4Eso from "./tek/tek4eso";
import Tek3Eso from "./tek/tek3eso";
import Tek2Bac from "./tek/tek2bac";
import Tek1Bac from "./tek/tek1bac";
import TekFPB from "./tek/tekfpb";
import TekFPM from "./tek/tekfpm";
import TekPdf from "./tek/tek.pdf";

function InformeTek(props) {
  const dispatch = useDispatch();
  const { query, search } = useLocation();

  const { t } = useTranslation();
  const [answers, setAnswers] = useState([]);
  const [userQuest, setUserQuest] = useState();
  const [code, setCode] = useState();
  const [course, setCourse] = useState();
  const [answersNoGame3, setAnswersNoGame3] = useState(null);
  const [answersNoGame4, setAnswersNoGame4] = useState(null);
  const [answersNoGame5, setAnswersNoGame5] = useState(null);
  const [answersNoGame6, setAnswersNoGame6] = useState(null);
  const [answersCervo, setAnswersCervo] = useState(null);
  const [answersTek, setAnswersTek] = useState(null);
  const [questionnaires, setQuestionnaires] = useState([]);
  const [timeline, setTimeline] = useState(null);

  const year = +new URLSearchParams(search).get('year');

  const [levels, setLevels] = useState();
  const [studentAreaCervo, setStudentAreaCervo] = useState();
  const setQuest = (course) => {
    const quests = {
      '3º ESO': 'TEK3ESO',
      '4º ESO': 'TEK4ESO',
      '1º Bachillerato': 'TEK1BAC',
      '2º Bachillerato': 'TEK2BAC',
      'FP Grado Básico': 'TEKFPB',
      'FP Grado Medio': 'TEKFPM',
    }

    setUserQuest(quests[course])

    const answersPath = userType === 'STUDENT' ? `/v1/student/answers/${quests[course]}?withResponses=true&year=${year}` : `/v1/student/${studentUid}/answers/${quests[course]}?withResponses=true&year=${year}`;

    xcService.getToken(answersPath).then(({ data }) => {
      setAnswers(data.data);
      let mAgrupado = _.groupBy(data.data, "year");
      let mTimeLine = [];
      Object.keys(mAgrupado).map((key, i) => {
        let mYear = "20" + mAgrupado[key][0].year + "/20" + (+mAgrupado[key][0].year + 1);
        let mMessages = "";
        mAgrupado[key].map(item => {
          if (mMessages !== "") {
            mMessages += "<br />";
          }
          mMessages += showResponse(item)

        })
        mTimeLine.push({
          date: mYear,
          message: mMessages
        })
      });

      setTimelineData(mTimeLine)
    })

  }

  const [timelineData, setTimelineData] = useState([]);

  const storage = localOrSessionStore({ key: variables.REMEMBER });
  const user = JSON.parse(storage.getItem(variables.USER));

  const userType = storage.getItem(variables.USER_TYPE);
  const studentUid = new URLSearchParams(search).get('user');
  const [studentProfile, setStudentProfile] = useState();
  const [studentHistory, setStudentHistory] = useState();

  const [studentArea, setStudentArea] = useState();

  const getHistory = () => {
    if (studentUid) {

      xcService.getToken(`/v1/${userType === 'STUDENT' ? `student/profile/history/` : `master/${studentUid}/history/`}${year}`)
        .then(({ data }) => {
          setStudentHistory(data.data)

          let mStudentProfile = studentProfile;

          setQuest(data.data.course.name);
          setCourse(data.data.course.name)
          mStudentProfile.course.id = data.data.course.id;
          mStudentProfile.course.name = data.data.course.name;
          setStudentProfile(mStudentProfile);
        })
    }
  }

  useEffect(() => {

    if (studentProfile) {

      getHistory(studentUid)

    }

  }, [studentProfile]);

  useEffect(() => {

    if (studentUid && (userType !== 'STUDENT')) xcService.getToken(`/v1/student/${studentUid}/profile`)
      .then(({ data }) => {
        setStudentProfile(data.data)
        //getHistory(studentUid)
      })
    else {
      //setStudentProfile(localOrSessionStore({key: variables.USER}))

      xcService.getToken('/v1/me').then(({ data }) => {
        setStudentProfile(data.data)
        //getHistory(studentUid)
      });

    }

  }, [studentUid]);
  var questionnairesData = useSelector((state) => state.questionnaireReducer.questionnairesData);
  var questionnairesDataError = useSelector((state) => state.questionnaireReducer.questionnairesDataError);

  var answersData = useSelector((state) => state.questionnaireReducer.answersData);
  var answersDataError = useSelector((state) => state.questionnaireReducer.answersDataError);

  var getStudentArea = useSelector((state) => state.questionnaireReducer.getStudentArea);

  const showResponse = (item) => {
    let mQuestion = item.assessment?.question;
    if (item.response) {
      return "<strong>" + mQuestion + "</strong> " + item.response?.question
    } else {
      if (item.degree) {
        return "<strong>" + mQuestion + "</strong> " + item.degree.title + " (" + item.degree.family + ")"
      }
      if (item.subject) {
        return "<strong>" + mQuestion + "</strong> " + item.subject.modality + " - " + item.subject.subject
      }
    }
  }

  useEffect(() => {
    if (answersData) {
      setAnswers(answersData);
      let mAgrupado = _.groupBy(answersData, "year");
      let mTimeLine = [];
      Object.keys(mAgrupado).map((key, i) => {
        let mYear = "20" + mAgrupado[key][0].year + "/20" + (+mAgrupado[key][0].year + 1);
        let mMessages = "";
        mAgrupado[key].map(item => {
          if (mMessages !== "") {
            mMessages += "<br />";
          }
          mMessages += showResponse(item)

        })
        mTimeLine.push({
          date: mYear,
          message: mMessages
        })
      });

      setTimelineData(mTimeLine)

    }
  }, [answersData, answersDataError])

  useEffect(() => {

    dispatch(questionnaireActions.getArea())
    const variablesRequests = [
      'POTENCACAD23',
      'WBACADTOT23',
      'AUTOCONFV23',
      'SWPERTOT23',
      'INFVOCTOT23',
      'MEDIA_NIVEL_ACADEMICO',
      'DESV_NIVEL_ACADEMICO',
      'MEDIA_INFORMACION_VOCA',
      'DESV_INFORMACION_VOCA',
      'MEDIA_AUTOCONFIANZA',
      'DESV_AUTOCONFIANZA',
      'MEDIA_BIENESTAR_ESCOLAR',
      'DESV_BIENESTAR_ESCOLAR',
      'DESV_AUTOCONFIANZA',
      'MEDIA_BIENESTAR_PERSONAL',
      'DESV_BIENESTAR_PERSONAL'
    ].map(variable =>
      xcService.getToken(`/v1/${userType === 'STUDENT' ? 'student' : 'tutor'}/${studentUid}/variable/${variable}?year=${year}`)
    );
    Promise.all(variablesRequests)
      .then(arr => arr.reduce((obj, { data }) => ({ ...obj, ...data.data }),{}) )
      .then(vars => {
        setLevels([
          {
            name: t("informes.respuestas.tres1"),
            points: vars.POTENCACAD23 ?
              vars.POTENCACAD23 : -100,
            qName: t("informes.pendiente.thistoria")
          }, {
            name: t("informes.respuestas.tres2"),
            points: vars.INFVOCTOT23 ? vars.INFVOCTOT23 : -100,
            qName: t("informes.pendiente.treflexion")
          }, {
            name: t("informes.respuestas.tres3"),
            points: vars.AUTOCONFV23 ? vars.AUTOCONFV23 : -100,
            qName: t("informes.pendiente.treflexion")
          }, {
            name: t("informes.respuestas.tres4"),
            points: vars.WBACADTOT23 ? vars.WBACADTOT23 : -100,
            qName: t("informes.pendiente.tmibienestar")
          }, {
            name: t("informes.respuestas.tres5"),
            points: vars.SWPERTOT23 ? vars.SWPERTOT23 : -100,
            qName: t("informes.pendiente.tmibienestar")
          },
        ])
      })
  }, []);

  useEffect(() => {
    if (!userType) return;

    const questionPath = userType === 'STUDENT' ? `/v1/student/myquestionnaires?year=${year}` : `/v1/student/${studentUid}/questionnaires?year=${year}`;
    xcService.getToken(questionPath).then(({ data }) => {

      setQuestionnaires(data.data)
      let mNoGame3 = _.filter(
        data.data, function (o) {
          return o.code === 'NOGAM3';
        }
      );
      if (mNoGame3 && mNoGame3[0] && mNoGame3[0].totresp === mNoGame3[0].tota) {
        const mUrl = userType === 'STUDENT' ? `/v1/student/answers/NOGAM3?withResponses=true&year=${year}` : `/v1/student/${studentUid}/answers/NOGAM3?withResponses=true&year=${year}`;
        xcService.getToken(mUrl).then(({ data }) =>

          setAnswersNoGame3(data.data));

      }

      let mTemp = _.filter(
        data.data, function (o) {
          return o.code === 'NOGAM4';
        }
      );
      if (mTemp && mTemp[0] && mTemp[0].totresp === mTemp[0].tota) {
        const mUrl = userType === 'STUDENT' ? `/v1/student/answers/NOGAM4?withResponses=true&year=${year}` : `/v1/student/${studentUid}/answers/NOGAM4?withResponses=true&year=${year}`;

        xcService.getToken(mUrl).then(({ data }) =>
          setAnswersNoGame4(data.data));
      }

      mTemp = _.filter(
        data.data, function (o) {
          return o.code === 'NOGAM5';
        }
      );
      if (mTemp && mTemp[0] && mTemp[0].totresp === mTemp[0].tota) {
        const mUrl = userType === 'STUDENT' ? `/v1/student/answers/NOGAM5?withResponses=true&year=${year}` : `/v1/student/${studentUid}/answers/NOGAM5?withResponses=true&year=${year}`;

        xcService.getToken(mUrl).then(({ data }) =>
          setAnswersNoGame5(data.data));
      }

      mTemp = _.filter(
        data.data, function (o) {
          return o.code === 'NOGAM6';
        }
      );
      // if (mTemp && mTemp[0] && mTemp[0].totresp === mTemp[0].tota) {
      const mUrl2 = userType === 'STUDENT' ? `/v1/student/answers/NOGAM6?withResponses=true&year=${year}` : `/v1/student/${studentUid}/answers/NOGAM6?withResponses=true&year=${year}`;
      xcService.getToken(mUrl2).then(({ data }) =>
        setAnswersNoGame6(data.data));
      //   }

      mTemp = _.filter(
        data.data, function (o) {
          return o.code === 'CERVO';
        }
      );
      // if (mTemp && mTemp[0] && mTemp[0].totresp === mTemp[0].tota) {
      const mUrl3 = userType === 'STUDENT' ? `/v1/student/answers/CERVO?withResponses=true&year=${year}` :
        `/v1/student/${studentUid}/answers/CERVO?year=${year}`;
      xcService.getToken(mUrl3).then(({ data }) =>
        setAnswersCervo(data.data));
      //   }


      const areaPath = userType === 'STUDENT' ? `/v1/student/area/CEIBA?year=${year}` : `/v1/student/${studentUid}/area/CEIBA?year=${year}`
      xcService.getToken(areaPath).then(({ data }) => setStudentArea(data.data));

      const areaCevoPath = userType === 'STUDENT' ? `/v1/student/area/CERVO?year=${year}` : `/v1/student/${studentUid}/area/CERVO?year=${year}`
      xcService.getToken(areaCevoPath).then(({ data }) => setStudentAreaCervo(data.data));



    })

  }, [userType, course]);

  const getResponse = (array, code) => {
    let mResult = _.filter(array, function (o) {
      return (o.assessment && o.assessment.order === code)
    });


    if (mResult && mResult.length > 0) {

      if (mResult[0].points === 99 || mResult[0].points === 999) {
        return <p></p>;
      } else {
        if (mResult[0].assessment.questionType === "RATING") {

          return <p>{mResult[0].points}</p>
        } else if (mResult[0].assessment.questionType === "RATINGOB") {

          return <p>{mResult[0].yesno === 1 ? t("yes") + ". " + mResult[0].points : t("no")}</p>
        } else {
          if (mResult[0].response) {
            return <p>{mResult[0]?.response?.question}</p>
          } else {
            if (mResult[0].degree) {
              return <p>{mResult[0]?.degree?.family} {mResult[0]?.degree?.title}</p>
            }
          }
        }
      }
      return "";

    } else {
      return ""
    }

  }

  return (
    <div className={"container dasboard-informes"}>
      <div className={"gridInformes"}>
        <div className={"colLeftInformes"}>
          <h3>{t("informes.title")}</h3>
          <h4>{t("informes.teksubtitle")}</h4>

          {studentProfile && <CardStudent t={t} studentProfile={studentProfile} studentHistory={studentHistory} />}

          <h6>{t("informes.preferente")}</h6>
          <div className={"cardArea"}>
            <div className={"img"}>
              {studentArea &&
                <img src={`/assets/img/${studentArea.area.image}`} />
              }
            </div>
            <div className={"title"}>{studentArea ? studentArea.area.name :
              <span dangerouslySetInnerHTML={{ __html: t("informes.pendiente.refvocacional") }} />
            }</div>
          </div>
          <p className={"is-desktop changefont"}>{t("informes.comenta")}</p>
        </div>
        <div className={"colRightInformes"}>
          <div className={"colRightInformesTop"}>
            <div className="listaAreas listaAreas--timeline listAreas-scroll">
              {studentProfile && answers.length > 0 && userQuest === "TEK4ESO" &&
                <Tek4Eso setTimeline={setTimeline} answers={answers} studentProfile={studentProfile} />
              }
              {studentProfile && answers.length > 0 && userQuest === "TEK3ESO" &&
                <Tek3Eso setTimeline={setTimeline} answers={answers} studentProfile={studentProfile} />
              }
              {studentProfile && answers.length > 0 && userQuest === "TEK1BAC" &&
                <Tek1Bac setTimeline={setTimeline} answers={answers} studentProfile={studentProfile} />
              }
              {studentProfile && answers.length > 0 && userQuest === "TEK2BAC" &&
                <Tek2Bac setTimeline={setTimeline} answers={answers} studentProfile={studentProfile} />
              }
              {studentProfile && answers.length > 0 && userQuest === "TEKFPB" &&
                <TekFPB setTimeline={setTimeline} answers={answers} studentProfile={studentProfile} />
              }
              {studentProfile && answers.length > 0 && userQuest === "TEKFPM" &&
                <TekFPM setTimeline={setTimeline} answers={answers} studentProfile={studentProfile} />
              }

            </div>

            <div className={"listaRespuestas"}>
              <p className={"title"} dangerouslySetInnerHTML={{ __html: t("informes.tektusrespuestas") }} />
              <div className={"contentCardRespuestas"}>

                <List
                  grid={{ column: 1 }}
                  header={null}
                  footer={null}
                  dataSource={levels}
                  renderItem={item => (
                    <List.Item>
                      <div className={"headerItem headerItemInforme"}>
                        <>
                          <>
                            {item.points !== 99 && item.points !== -100 ?

                              <div style={{
                                borderBottomRightRadius: 18,
                                borderTopRightRadius: 18,
                                minWidth: 192,
                                width: `${(item.points === 999 ? 0 : 10 * item.points)}%`
                              }}
                                className={`txtPoints ${item.points < 5 ? "redBar" :
                                  item.points >= 5 && item.points < 8 ? "yellowBar" : item.points === 999 ? "" : "greenBar"
                                  } informeBarra`}>
                                <span>{item.name}</span></div> :
                              <div style={{ color: "#8C8C8C" }}>{
                                item.points !== -100 &&
                                t("indeciso")}</div>
                            }
                          </>
                          {item.points !== 99 && (
                            <span className={"pointsInforme"}>
                              {(item.points) === -100 ? `${t("informes.pendiente.general")} ${item.qName}` : item.points === 999 ? t('indeciso') : item.points}
                            </span>
                          )}
                        </>
                      </div>
                    </List.Item>
                  )}
                />

                <div className={"cardRespuesta"}>
                  <p className={"title"}>{t("informes.respuestas.respuesta2")}</p>
                  {answersCervo && answersCervo.length > 0 ?
                    <p>{studentAreaCervo && studentAreaCervo.area.like}</p>
                    :
                    <p dangerouslySetInnerHTML={{ __html: t("informes.pendiente.valvocacional") }} />
                  }

                </div>
                <div className={"cardRespuesta"}>
                  <p className={"title"}>{t("informes.respuestas.respuesta61")}</p>
                  {answersNoGame3 && answersNoGame3.length > 0 && getResponse(answersNoGame3, 19) !== "" ?
                    getResponse(answersNoGame3, 19)
                    :
                    <p dangerouslySetInnerHTML={{ __html: t("informes.pendiente.reflexion") }} />
                  }

                </div>

                <div className={"cardRespuesta"}>
                  <p className={"title"}>{t("informes.respuestas.respuesta62")}</p>
                  {answersNoGame5 && answersNoGame5.length > 0 ?
                    getResponse(answersNoGame5, 6)
                    :
                    <p dangerouslySetInnerHTML={{ __html: t("informes.pendiente.mihsitorial") }} />
                  }

                </div>

                <div className={"cardRespuesta"}>
                  <p className={"title"}>{t("informes.respuestas.respuesta63")}</p>
                  {answersNoGame5 && answersNoGame5.length > 0 ?
                    getResponse(answersNoGame5, 7)
                    :
                    <p dangerouslySetInnerHTML={{ __html: t("informes.pendiente.mihsitorial") }} />
                  }

                </div>
                <div className={"cardRespuesta"}>
                  <p className={"title"}>{t("informes.respuestas.respuesta64")}</p>
                  {answersNoGame5 && answersNoGame5.length > 0 ?
                    getResponse(answersNoGame5, 11)
                    :
                    <p dangerouslySetInnerHTML={{ __html: t("informes.pendiente.mihsitorial") }} />
                  }

                </div>
                <div className={"cardRespuesta"}>
                  <p className={"title"}>{t("informes.respuestas.respuesta65")}</p>
                  {answersNoGame6 && answersNoGame6.length > 0 ?
                    getResponse(answersNoGame6, 5)
                    :
                    <p dangerouslySetInnerHTML={{ __html: t("informes.pendiente.micontexto") }} />
                  }

                </div>
                <div className={"cardRespuesta"}>
                  <p className={"title"}>{t("informes.respuestas.respuesta66")}</p>
                  {answersNoGame4 && answersNoGame4.length > 0 ?
                    getResponse(answersNoGame4, 14)
                    :
                    <p dangerouslySetInnerHTML={{ __html: t("informes.pendiente.mibienestar") }} />
                  }

                </div>
              </div>
            </div>
          </div>

          <p className={"is-mobile"}>{t("informes.comenta")}</p>
          <div className={"colRightInformesBottom"}>
            {studentProfile && answers && answers.length > 0 && timeline &&

              <TekPdf forDownload={false} timeline={timeline} props={props} studentProfile={studentProfile}
                answers={answers} levels={levels}
                getStudentArea={getStudentArea}
                answersCervo={answersCervo}
                answersNoGame3={answersNoGame3}
                answersNoGame4={answersNoGame4}
                answersNoGame5={answersNoGame5}
                answersNoGame6={answersNoGame6}
                studentHistory={studentHistory}
                studentAreaCervo={studentAreaCervo} course={course}
                studentArea={studentArea} />

            }
            {1 === 2 &&
              <Button
                icon={<ShareAltOutlined />}
                className="primaryButton">
                {t("share")}
              </Button>}
          </div>
        </div>
      </div>
    </div>
  )
}

export default withTranslation()(InformeTek);

